import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { ReviewPayload } from '@/services/faq/faq.mutation';
import { faqQueries } from '@/services/faq/faq.queries';

export const useRatingsPreview = (resId: ReviewPayload) => {
  const { data, isLoading } = useQuery({
    ...faqQueries.ratingsPreview(resId),
  });
  return { ratingPreview: data?.data, loading: isLoading };
};
